// Module: dsTokens.js
// Purpose: Resolve DeeTrade Design-System CSS custom-property tokens to concrete
//          color values for JS contexts that CANNOT use var() — MUI `alpha()`,
//          SVG presentation attributes (stroke=/fill=), and canvas fillStyle.
//          The semantic --success/--danger/--warning (and brand --color-profit/loss)
//          are defined once in :root and are theme-invariant, so a lazy one-time
//          resolve via getComputedStyle is safe and stable across light/dark.

// Read a CSS custom property off :root; fall back to a literal if unavailable (SSR/tests).
export function resolveToken(name, fallback = "") {
  if (typeof window === "undefined" || typeof document === "undefined" || !document.documentElement) {
    return fallback;
  }
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

// Concrete DS status/brand colors for JS use. Getters resolve lazily (after CSS is loaded).
export const dsColors = {
  get success() { return resolveToken("--success", "#22c55e"); },
  get danger()  { return resolveToken("--danger", "#ef4444"); },
  get warning() { return resolveToken("--warning", "#f59e0b"); },
  get profit()  { return resolveToken("--color-profit", "#00C292"); },
  get loss()    { return resolveToken("--color-loss", "#E46A76"); },
};

export default dsColors;
